<template>
    <div class="language-dropdown" v-click-outside="() => isOpen = false">
        <button class="dropdown-activator" @click="isOpen = !isOpen">
            <span :class="`fi fi-${selectedFlag}`"></span>
            <span class="dropdown-arrow">▾</span>
        </button>
        <ul v-if="isOpen" class="dropdown-list">
            <li
                v-for="lang in availableLanguage"
                :key="lang.code"
                class="dropdown-item"
                @click="selectLanguage(lang.code)"
            >
                <span :class="`fi fi-${lang.flag}`"></span>
                <span class="dropdown-item-label">{{ lang.label }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
import 'flag-icons/css/flag-icons.min.css';

export default {
    name: 'LanguageDropdown',
    data() {
        return {
            selectedLanguage: 'ja_JP',
            isOpen: false,
            availableLanguage: [
                { code: 'ja_JP', label: '日本語', flag: 'jp' },
                { code: 'en_US', label: 'English', flag: 'us' },
                // { code: 'id_ID', label: 'Bahasa Indonesia', flag: 'id' },
                { code: 'kr_KR', label: '한국어', flag: 'kr' }
            ]
        }
    },
    computed: {
        selectedFlag() {
            const lang = this.availableLanguage.find(l => l.code === this.selectedLanguage);
            return lang ? lang.flag : '';
        }
    },
    methods: {
        selectLanguage(code) {
            this.selectedLanguage = code;
            this.isOpen = false;
            // vue-i18nのlocaleを変更
            if (this.$i18n) {
                this.$i18n.locale = code;
            } else if (this.$root && this.$root.$i18n) {
                this.$root.$i18n.locale = code;
            }
        }
    },
    mounted() {
        const browserLang = navigator.language || navigator.userLanguage;
        if (browserLang.startsWith('ja')) {
            this.selectedLanguage = 'ja_JP';
        } else if (browserLang.startsWith('en')) {
            this.selectedLanguage = 'en_US';
        } else if (browserLang.startsWith('ko')) {
            this.selectedLanguage = 'kr_KR';
        }
        // 初期言語をvue-i18nに反映
        if (this.$i18n) {
            this.$i18n.locale = this.selectedLanguage;
        } else if (this.$root && this.$root.$i18n) {
            this.$root.$i18n.locale = this.selectedLanguage;
        }
    }
}
</script>

<style scoped>
.language-dropdown {
  position: relative;
  /* margin-left: auto; */
}

.dropdown-activator {
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 6px;
  color: #ffffff;
  cursor: pointer;
  padding: 5px 10px;
  font-size: 0.95rem;
  transition: background 0.15s, border-color 0.15s;
}

.dropdown-activator:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.8);
}

.dropdown-arrow {
  font-size: 0.8rem;
  line-height: 1;
  opacity: 0.8;
}

.dropdown-list {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  list-style: none;
  min-width: 160px;
  overflow: hidden;
  z-index: 200;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  cursor: pointer;
  color: #333333;
  font-size: 0.9rem;
  transition: background 0.12s;
}

.dropdown-item:hover {
  background: var(--color-secondary);
  color: var(--color-primary);
}

.dropdown-item-label {
  white-space: nowrap;
}
</style>
